import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, RefreshControl, Platform, Dimensions } from 'react-native';
import { FlashList } from '@shopify/flash-list';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { BackgroundGradient, Loader, SafeAreaView } from '../../components';
import * as rtApi from '../../components/Api';
import ProjectPreview from '../../components/Projects/ProjectPreview';
import { useFocusEffect } from '@react-navigation/native';
import UserState from '../../src/contexts/UserState';

const DisputesScreen = ({ navigation }) => {
  const [user, setUser] = React.useContext(UserState);

  const [loading, setLoading] = React.useState(false);
  const [disputes, setDisputes] = React.useState([]);

  // runs each time screen is focused
  useFocusEffect(
    React.useCallback(() => {
      getDisputes();
      return () => rtApi.cancel();
    }, [])
  );
  React.useEffect(() => {
    // when parent tab button ('Projects') is pressed
    const unsubscribe = navigation.getParent().addListener('tabPress', (e) => {
      console.log('tabPress');
      // scrollRef.current.scrollTo({ x: 0, y: 0, animated: true });
      getDisputes();
    });
    return unsubscribe;
  }, [navigation]);

  const getDisputes = async (userId) => {
    setLoading(true);
    rtApi.get(`agreements?dispute=yes`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setDisputes(data.agreements);
    })
    .catch((error) => {
      console.log(error);
    }).finally(() => {
      setLoading(false)
    });
  }

  const Header = () => {
    return (
      <TouchableOpacity style={styles.imgTextContainer} activeOpacity={0.6} onPress={() => navigation.navigate('HowItWorks')}>
        <Image style={[CS.responsiveImage, webImgStyle()]} source={require('../../assets/img/how_disputes_work.png')} />
        <View style={styles.disputeTextContainer}>
          <Text style={[CS.smallTitle, CS.lightText, { marginTop: 0, marginBottom: 5 }]}>How the dispute process works</Text>
          <Text style={[CS.smallText, CS.lightText]}>Read more</Text>
        </View>
      </TouchableOpacity>
    )
  }

  const webImgStyle = () => {
    if(Platform.OS === 'web'){
      const ratio = 720 / 1000;
      const width = Dimensions.get('window').width;
      return {
        width: '100%',
        height:  (width >= 768 ? 768 : width) * ratio,
      }
    }else{
      const ratio2 = 1000 / 720;
      return {
        aspectRatio: ratio2
      }
    }
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <View style={[CS.innerContainer, { paddingVertical: 10 }]}>
        <Text style={[CS.largeText, CS.lightText, CS.centerText, CS.boldText, { marginBottom: 10 }]}>Disputes</Text>
        {/* screen content */}
        {/* <View> */}
          <FlashList
            data={disputes}
            renderItem={({ item }) => <ProjectPreview project={item} />}
            ItemSeparatorComponent={() => (<View style={{ 'height': 20 }} />)}
            keyExtractor={item => item.id.toString()}
            ListHeaderComponent={Header}
            refreshControl={<RefreshControl refreshing={loading} onRefresh={() => getDisputes()} colors={[Colors.yellow]} tintColor={Colors.yellow} />}
            ListEmptyComponent={() => <Text style={[CS.smallText, CS.lightBlueText, CS.centerText]}>You have no disputes at the moment.</Text>}
          />
        {/* </View> */}
      </View>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  imgTextContainer: {
    width: '100%',
    marginBottom: 20,
  },
  disputeTextContainer: {
    position: 'absolute',
    bottom:20,
    left:20,
  }
});

export default DisputesScreen;